import React from "react";
import { FiPlus, FiClipboard } from "react-icons/fi";
import { WorkoutPlan } from "../../../types";
import {
  SectionHeader,
  PrimarySectionButton,
  EmptyState,
  WorkoutPlanCard,
  LIST_GRID_CLASS,
} from "./StudentManagementModalComponents";
import { WorkoutTabSkeleton } from "./StudentManagementModalSkeletons";

interface StudentManagementModalWorkoutTabProps {
  workoutList: WorkoutPlan[];
  loading: boolean;
  onNewPlan: () => void;
  onEditPlan: (plan: WorkoutPlan) => void;
  onDeletePlan: (plan: WorkoutPlan) => void | Promise<void>;
}

export default function StudentManagementModalWorkoutTab({
  workoutList,
  loading,
  onNewPlan,
  onEditPlan,
  onDeletePlan,
}: StudentManagementModalWorkoutTabProps) {
  if (loading) {
    return <WorkoutTabSkeleton />;
  }

  return (
    <div className="space-y-3 sm:space-y-4 md:space-y-6">
      <SectionHeader
        title="Planos de Treino"
        description="Gerencie os treinos personalizados"
        actionButton={
          <PrimarySectionButton
            icon={FiPlus}
            label="Novo Plano"
            onClick={onNewPlan}
          />
        }
      />

      {workoutList.length === 0 ? (
        <EmptyState
          icon={FiClipboard}
          title="Nenhum plano de treino encontrado"
          description="Crie o primeiro plano de treino personalizado"
        />
      ) : (
        <div className={LIST_GRID_CLASS}>
          {workoutList.map((plan) => (
            <WorkoutPlanCard
              key={plan.id}
              plan={plan}
              onEdit={() => onEditPlan(plan)}
              onDelete={async () => {
                if (
                  window.confirm(
                    "Tem certeza que deseja excluir este plano?",
                  )
                ) {
                  await onDeletePlan(plan);
                }
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
}
